/**
 * Promo Preview Component
 * 
 * Shows preview of promo details as user fills the form
 */

import React from 'react';
import { PromoFormData } from '../../../../../api/promos/types';
import '../../../Campaigns/CreateCampaign/components/CampaignPreview.css';

interface PromoPreviewProps {
  formData: PromoFormData;
  currentStep: number;
}

const PromoPreview: React.FC<PromoPreviewProps> = ({
  formData,
  currentStep,
}) => {
  return (
    <div className="campaign-preview-card">
      <h6 className="campaign-preview-header">Preview</h6>
      <div className="campaign-preview-item">
        <span className="campaign-preview-label">Promo Name</span>
        <span className="campaign-preview-content">
          {formData.name || '-'}
        </span>
      </div>
      <div className="campaign-preview-item">
        <span className="campaign-preview-label">Domain</span>
        <span className="campaign-preview-content">
          {formData.domain || '-'}
        </span>
      </div>
      <div className="campaign-preview-item">
        <span className="campaign-preview-label">Transaction Type</span>
        <span className="campaign-preview-content">
          {formData.transactionType || '-'}
        </span>
      </div>
      <div className="campaign-preview-item">
        <span className="campaign-preview-label">Discount Level</span>
        <span className="campaign-preview-content">
          {formData.benefit?.level || '-'}
        </span>
      </div>
      <div className="campaign-preview-item">
        <span className="campaign-preview-label">Eligibility</span>
        <span className="campaign-preview-content">
          {formData.eligibility?.userType || '-'}
        </span>
      </div>
      <div className="campaign-preview-item">
        <span className="campaign-preview-label">Validity</span>
        <span className="campaign-preview-content">
          {formData.validity?.startAt && formData.validity?.endAt 
            ? `${formData.validity.startAt} - ${formData.validity.endAt}`
            : '-'}
        </span>
      </div>
      <div className="campaign-preview-item">
        <span className="campaign-preview-label">Funded By</span>
        <span className="campaign-preview-content">
          {formData.funding?.fundedBy || '-'}
        </span>
      </div>
    </div>
  );
};

export default PromoPreview;
